export default "__VITE_ASSET__hD1i3GyoflofLbTk1JHt6A__"